import { axios } from "../../helper/axios";
import { TripDetailConstant } from "./TripDetailConstant";

const TripDetailApiData = {};

TripDetailApiData.getTripDetailApiData = ({
  from_date,
  to_date,
  search_term,
  page = 1,
  limit,
  trip_status
}) => {
  let qeuryParam = [];

  if (search_term) {
    qeuryParam.push(`search=${search_term}`);
  }
  if (from_date && to_date) {
    qeuryParam.push(`startDate=${from_date}&endDate=${to_date}`);
  }
  if (page) {
    qeuryParam.push(`page=${page}`);
  }
  if (limit) {
    qeuryParam.push(`limit=${limit}`);
  }
  if (trip_status) {
    qeuryParam.push(`trip_status=${trip_status}`);
  }

  // Join all parameters with '&'
  const queryString = qeuryParam.length ? `?${qeuryParam.join('&')}` : '';

  return axios.get(`${TripDetailConstant.TRIP_DETAIL_API}${queryString}`);
};

TripDetailApiData.exportTripDetailApiData = ({
  limit
}) => {
  let qeuryParam = [];

  if (limit) {
    qeuryParam.push(`limit=${limit}`);
  }

  const queryString = qeuryParam.length ? `?${qeuryParam.join('&')}` : '';

  return axios.get(`${TripDetailConstant.TRIP_DETAIL_API}${queryString}`);
};

export { TripDetailApiData };
